module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-center-up-52c7cff3e4bf692677d08bc29df283cb.svg";